/**
 * Soulgasm — Daily Sacred Tarot / Oracle Card Pull Module
 * Interactive 3D Tarot Deck with Archetype Guidance and Botanical Companions
 */

(function() {
  'use strict';

  var TAROT_DECK = [
    {
      "id": "the-magician",
      "number": "I",
      "name": "The Magician",
      "subtitle": "Weaver & Sacred Manifestation",
      "intention": "Everything you need is already in your hands. Weave dream into pattern and pattern into form. Your focused will makes the unseen real.",
      "line": {
        "handle": "weaver",
        "title": "Weaver",
        "archetype": "Weaver",
        "botanicals": "Limitless Possibility · Creative Action · Dream Work",
        "url": "/collections/weaver"
      }
    },
    {
      "id": "high-priestess",
      "number": "II",
      "name": "The High Priestess",
      "subtitle": "Priestess & Intuitive Knowing",
      "intention": "The veil between the seen and unseen is whisper-thin today. Trust the quiet impulses of your intuition over the noisy demands of logic.",
      "line": {
        "handle": "sapphire-flame",
        "title": "Sapphire Flame",
        "archetype": "Priestess",
        "botanicals": "Priestess · Devotion · Sovereignty",
        "url": "/collections/sapphire-flame"
      }
    },
    {
      "id": "the-empress",
      "number": "III",
      "name": "The Empress",
      "subtitle": "Great Mother & Sacred Holding",
      "intention": "You are held. Let yourself be nourished, protected, and loved fiercely, and offer that same unwavering devotion back to yourself and what you are growing.",
      "line": {
        "handle": "great-mother",
        "title": "Great Mother",
        "archetype": "Great Mother",
        "botanicals": "Unconditional Love · Devotion · Holding",
        "url": "/collections/great-mother"
      }
    },
    {
      "id": "strength",
      "number": "VIII",
      "name": "Strength",
      "subtitle": "Vital Force & Fully Claimed Power",
      "intention": "Meet the fierce current of life awakening within you with courage and unshrinking presence. Cross the threshold into your power. You do not fear the flame, you are made of it.",
      "line": {
        "handle": "between-the-fires",
        "title": "Between the Fires",
        "archetype": "Creator / Destroyer",
        "botanicals": "Ignition · Visibility · Aliveness",
        "url": "/collections/between-the-fires"
      }
    },
    {
      "id": "the-hermit",
      "number": "IX",
      "name": "The Hermit",
      "subtitle": "Wise Woman & The Inner Compass",
      "intention": "Carve out intentional quiet today. Step back from the world's opinions and light your path with your own inner lantern.",
      "line": {
        "handle": "the-knowing",
        "title": "The Knowing",
        "archetype": "Wise Woman",
        "botanicals": "Inner Knowing · Wise Woman · Self-Trust",
        "url": "/collections/the-knowing"
      }
    },
    {
      "id": "wheel-of-fortune",
      "number": "X",
      "name": "Wheel of Fortune",
      "subtitle": "Crone Wisdom & Sacred Timing",
      "intention": "Stand at the quiet doorway and let distraction fall away so what is essential becomes unmistakable. Release all urgency, listen beneath the noise, and trust the deeper rhythm carrying you into what comes next.",
      "line": {
        "handle": "winters-threshold",
        "title": "Winter's Threshold",
        "archetype": "Queen of Death",
        "botanicals": "Crone · Clarity · Ancestral Wisdom",
        "url": "/collections/winters-threshold"
      }
    },
    {
      "id": "the-hanged-man",
      "number": "XII",
      "name": "The Hanged Man",
      "subtitle": "Alchemical Goddess & Divine Surrender",
      "intention": "Pause and surrender the urge to control outcomes. Hanging between what was and what will be, you see everything from a new angle. Transformation begins in the stillness.",
      "line": {
        "handle": "the-turning",
        "title": "The Turning",
        "archetype": "Alchemical Goddess",
        "botanicals": "Crone · Clarity · Ancestral Wisdom",
        "url": "/collections/the-turning"
      }
    },
    {
      "id": "death",
      "number": "XIII",
      "name": "Death",
      "subtitle": "Queen of Death & Sacred Descent",
      "intention": "A sacred completion has arrived. Surrender what must wither so the fertile soil of your soul can nourish new life.",
      "line": {
        "handle": "crown-of-descent",
        "title": "Crown of Descent",
        "archetype": "Queen of Death",
        "botanicals": "Release · Surrender · Transformation",
        "url": "/collections/crown-of-descent"
      }
    },
    {
      "id": "temperance",
      "number": "XIV",
      "name": "Temperance",
      "subtitle": "Lady of Communion & Divine Harmony",
      "intention": "Alchemy happens when opposites blend in patient harmony. Attune to what is living and divine within and around you, and let balance return.",
      "line": {
        "handle": "lady-of-communion",
        "title": "Lady of Communion",
        "archetype": "Lady of Communion",
        "botanicals": "Attunement · Balance · Presence",
        "url": "/collections/lady-of-communion"
      }
    },
    {
      "id": "the-tower",
      "number": "XVI",
      "name": "The Tower",
      "subtitle": "Clearing & Sacred Restoration",
      "intention": "Let what has become stagnant or misaligned be cleared away to make space for what is true. Clear the field, return to your center, and enter again with nothing standing between you and the sacred.",
      "line": {
        "handle": "katharsis",
        "title": "Katharsis",
        "archetype": "Creator / Destroyer",
        "botanicals": "Purification · Protection · Restoration",
        "url": "/collections/katharsis"
      }
    },
    {
      "id": "the-star",
      "number": "XVII",
      "name": "The Star",
      "subtitle": "Goddess of Compassion & Boundless Grace",
      "intention": "Open your heart without condition and allow every part of yourself to be held without explanation. Love does not ask you to prove your worth. You already belong.",
      "line": {
        "handle": "agape",
        "title": "Agápē",
        "archetype": "Goddess of Compassion",
        "botanicals": "Unconditional Love · Holding · Emotional Support",
        "url": "/collections/agape"
      }
    },
    {
      "id": "the-moon",
      "number": "XVIII",
      "name": "The Moon",
      "subtitle": "Sacred Memory & Inner Knowing",
      "intention": "Listen beneath the noise to the ancient threads of memory and instinct living in your blood and breath. You do not need to search outside yourself. The path has been walked before you, and the wisdom has never left you.",
      "line": {
        "handle": "remembrance",
        "title": "Remembrance",
        "archetype": "Wise Woman",
        "botanicals": "Divine Feminine · Ancestral Wisdom · Protection",
        "url": "/collections/remembrance"
      }
    },
    {
      "id": "the-sun",
      "number": "XIX",
      "name": "The Sun",
      "subtitle": "Radiant Self & Embodied Vitality",
      "intention": "Stand openly in who you are and let what has grown quietly within step into the light. Take up space, share what is alive in you, and meet life with joy, confidence, and unapologetic presence.",
      "line": {
        "handle": "full-bloom",
        "title": "Full Bloom",
        "archetype": "Muse",
        "botanicals": "Visibility · Self-Expression · Expansion",
        "url": "/collections/full-bloom"
      }
    },
    {
      "id": "judgement",
      "number": "XX",
      "name": "Judgement",
      "subtitle": "Goddess of Love & Rebirth",
      "intention": "You are being called to rise. Answer with self-love, and step into your rebirth as who you truly are.",
      "line": {
        "handle": "aphrodites-ascent",
        "title": "Aphrodite's Ascent",
        "archetype": "Goddess of Love",
        "botanicals": "Rebirth · Self-Love · Open-Heartedness",
        "url": "/collections/aphrodites-ascent"
      }
    },
    {
      "id": "ace-of-wands",
      "number": "Ace",
      "name": "Ace of Wands",
      "subtitle": "Kindled Flame & Living Potential",
      "intention": "Tend the gentle spark of possibility rising within you without urgency or pressure. Intention is taking its first embodied form. Trust what is quietly waking and let it emerge in its own season.",
      "line": {
        "handle": "first-light",
        "title": "First Light",
        "archetype": "Primal Goddess",
        "botanicals": "Imbolc · Brigid · Sacred Emergence",
        "url": "/collections/first-light"
      }
    },
    {
      "id": "ace-of-pentacles",
      "number": "Ace",
      "name": "Ace of Pentacles",
      "subtitle": "The Seed Takes Root & Embodied Becoming",
      "intention": "What has been quietly preparing beneath the surface is ready to root and become real. You do not have to force what comes next. Give it earth, breath, and presence, for the seed already knows how to become.",
      "line": {
        "handle": "the-return",
        "title": "The Return",
        "archetype": "Alchemical Goddess",
        "botanicals": "Reawakening · Ostara · Vitality",
        "url": "/collections/the-return"
      }
    },
    {
      "id": "queen-of-wands",
      "number": "Queen",
      "name": "Queen of Wands",
      "subtitle": "Primal Goddess & magnetic power",
      "intention": "Inhabit your presence completely without diminishing your fire to make yourself easier to hold. Take up space, trust the primal wisdom of your body, and let yourself be seen without becoming less wild.",
      "line": {
        "handle": "untamed-soul-fire",
        "title": "Untamed Soul Fire",
        "archetype": "Primal Goddess",
        "botanicals": "Primal Goddess · Wild Feminine · Magnetism",
        "url": "/collections/untamed-soul-fire"
      }
    }
  ];

  function getCardImageUrl(cardId) {
    if (window.SOULGASM_TAROT_ASSETS && window.SOULGASM_TAROT_ASSETS.cards && window.SOULGASM_TAROT_ASSETS.cards[cardId]) {
      return window.SOULGASM_TAROT_ASSETS.cards[cardId];
    }
    return 'assets/tarot/tarot-' + cardId + '.jpg';
  }

  function getCardBackUrl() {
    if (window.SOULGASM_TAROT_ASSETS && window.SOULGASM_TAROT_ASSETS.cardBack) {
      return window.SOULGASM_TAROT_ASSETS.cardBack;
    }
    return 'assets/tarot-card-back.jpg';
  }

  function resolveLineUrl(line) {
    if (!line) return '#';
    if (window.location.protocol === 'file:' || window.location.pathname.endsWith('.html')) {
      return 'line-' + (line.handle || 'the-return') + '.html';
    }
    return line.url || ('/collections/' + (line.handle || 'all'));
  }

  var LINE_PRODUCT_IMAGES = {
    'agape': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/agape-sacred-smoke.png?v=1790300136',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/agape-spray.png?v=1790300152',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/agape-oil-10ml.png?v=1790300142'
    },
    'the-turning': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-sacred-smoke.png?v=1790300346',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-sacred-spray.png?v=1790300364',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-oil-10ml.png?v=1790300352'
    },
    'between-the-fires': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/between-the-fires-sacred-smoke.png?v=1790300201',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/between-the-fires-sacred-spray.png?v=1790300213',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/between-the-fires-oil-10ml.png?v=1790300207'
    },
    'aphrodites-ascent': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/aphrodites-ascent-sacred-smoke.png?v=1790300185',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/aphrodites-ascent-sacred-spray.png?v=1790300196',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/aphrodites-ascent-oil-10ml.png?v=1790300190'
    },
    'crown-of-descent': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/crown-of-descent-sacred-smoke.png?v=1790300219',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/crown-of-descent-spray.png?v=1790382554',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/crown-of-descent-oil-10ml.png?v=1790382531'
    },
    'first-light': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/first-light-sacred-smoke.png?v=1790300225',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/first-light-sacred-spray.png?v=1790300236',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/first-light-oil-10ml.png?v=1790300230'
    },
    'full-bloom': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/full-bloom-sacred-smoke.png?v=1790382576',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/full-bloom-sacred-spray.png?v=1790382598',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/full-bloom-oil-10ml.png?v=1790382617'
    },
    'great-mother': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/great-mother-sacred-smoke.png?v=1790300246',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/great-mother-sacred-spray_c168bd39-c984-466e-9092-a2b1356ddc79.png?v=1792417002',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/great-mother-oil-10ml.png?v=1790300251'
    },
    'katharsis': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/katharsis-sacred-smoke.png?v=1790300260'
    },
    'lady-of-communion': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/lady-of-communion-sacred-smoke.png?v=1790300266',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/lady-of-communion-sacred-spray.png?v=1790300282',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/lady-of-communion-oil-10ml.png?v=1790300272'
    },
    'remembrance': {
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/remembrance-smokeless-sacred-spray-framed.png?v=1791411356',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/remembrance-oil-10ml.png?v=1791411349'
    },
    'sapphire-flame': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/sapphire-flame-sacred-smoke.png?v=1790300287',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/sapphire-flame-sacred-spray.png?v=1790300302',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/sapphire-flame-oil-10ml.png?v=1790300293'
    },
    'the-knowing': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-knowing-sacred-smoke.png?v=1790382643',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-knowing-sacred-spray.png?v=1790382663',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-knowing-oil-10ml.png?v=1790382682'
    },
    'the-return': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-sacred-smoke.png?v=1790300307',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-smokeless-sacred-spray.png?v=1790300322',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-oil-10ml.png?v=1790300313'
    },
    'untamed-soul-fire': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/untamed-soul-fire-sacred-smoke.png?v=1790300328',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/untamed-soul-fire-sacred-spray.png?v=1792417009',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/untamed-soul-fire-oil-10ml.png?v=1790300335'
    },
    'weaver': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/weaver-sacred-smoke.png?v=1790382707',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/weaver-sacred-spray.png?v=1790382727',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/weaver-oil-10ml.png?v=1790382748'
    },
    'winters-threshold': {
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-sacred-smoke.png?v=1790300346',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-sacred-spray.png?v=1790300364',
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/winters-threshold-oil-10ml.png?v=1790300352'
    }
  };

  function getLineImages(handle) {
    var key = (handle || '').toLowerCase().replace(/_/g, '-');
    if (LINE_PRODUCT_IMAGES[key]) {
      return LINE_PRODUCT_IMAGES[key];
    }
    return {
      oil: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-oil-10ml.png?v=1790300313',
      smoke: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-sacred-smoke.png?v=1790300307',
      spray: 'https://cdn.shopify.com/s/files/1/0716/1236/7031/files/the-return-smokeless-sacred-spray.png?v=1790300322'
    };
  }

  var currentDrawnCard = null;
  var isAnimating = false;

  function initTarotModule() {
    var tarotSection = document.getElementById('daily-tarot-section') || document.getElementById('daily-tarot');
    if (!tarotSection) return;

    var deckFanContainer = tarotSection.querySelector('.tarot-deck-fan');
    var drawBtn = tarotSection.querySelector('#tarot-draw-btn');
    var modal = document.getElementById('tarot-reveal-modal');
    var modalCloseBtn = modal ? modal.querySelector('.tarot-modal-close-btn') : null;
    var modalBackdrop = modal ? modal.querySelector('.tarot-modal-backdrop') : null;

    if (!deckFanContainer) return;

    renderDeckFan(deckFanContainer);

    if (drawBtn) {
      drawBtn.addEventListener('click', function(e) {
        e.preventDefault();
        drawRandomCard();
      });
    }

    if (modalCloseBtn) {
      modalCloseBtn.addEventListener('click', closeModal);
    }

    if (modalBackdrop) {
      modalBackdrop.addEventListener('click', closeModal);
    }

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal && modal.classList.contains('active')) {
        closeModal();
      }
    });
  }

  function renderDeckFan(container) {
    container.innerHTML = '';
    var numCards = 5;
    var angles = [-16, -8, 0, 8, 16];
    var offsetsX = [-110, -55, 0, 55, 110];
    var offsetsY = [12, 4, 0, 4, 12];
    var backUrl = getCardBackUrl();

    for (var i = 0; i < numCards; i++) {
      (function(idx) {
        var cardEl = document.createElement('div');
        cardEl.className = 'tarot-deck-card card-index-' + idx;
        cardEl.setAttribute('role', 'button');
        cardEl.setAttribute('tabindex', '0');
        cardEl.setAttribute('aria-label', 'Draw card ' + (idx + 1) + ' from the sacred deck');
        cardEl.style.setProperty('--card-rot', angles[idx] + 'deg');
        cardEl.style.setProperty('--card-x', offsetsX[idx] + 'px');
        cardEl.style.setProperty('--card-y', offsetsY[idx] + 'px');
        cardEl.style.zIndex = (idx + 1);

        cardEl.innerHTML = '<div class="tarot-card-inner">' +
          '<div class="tarot-card-face tarot-card-back">' +
            '<div class="tarot-back-frame">' +
              '<img src="' + backUrl + '" alt="Soulgasm Sacred Amphora Tarot Card Back" class="tarot-card-back-img">' +
            '</div>' +
          '</div>' +
        '</div>';

        cardEl.addEventListener('click', function() {
          if (!isAnimating) {
            drawRandomCard(cardEl);
          }
        });

        cardEl.addEventListener('keydown', function(e) {
          if ((e.key === 'Enter' || e.key === ' ') && !isAnimating) {
            e.preventDefault();
            drawRandomCard(cardEl);
          }
        });

        container.appendChild(cardEl);
      })(i);
    }
  }

  function drawRandomCard(clickedEl) {
    if (isAnimating) return;
    isAnimating = true;

    var randomIndex = Math.floor(Math.random() * TAROT_DECK.length);
    currentDrawnCard = TAROT_DECK[randomIndex];

    var cardElements = document.querySelectorAll('.tarot-deck-card');
    var targetEl = clickedEl || cardElements[2] || cardElements[0];

    if (targetEl) {
      targetEl.classList.add('drawing-active');
    }

    setTimeout(function() {
      populateModal(currentDrawnCard);
      openModal();
      if (targetEl) {
        targetEl.classList.remove('drawing-active');
      }
      isAnimating = false;
    }, 450);
  }

  function populateModal(card) {
    var modal = document.getElementById('tarot-reveal-modal');
    if (!modal || !card) return;

    var cardImageUrl = getCardImageUrl(card.id);
    var lineImgs = getLineImages(card.line ? card.line.handle : "");

    var cardSlot = modal.querySelector('.tarot-revealed-card-slot');
    if (cardSlot) {
      cardSlot.innerHTML = '<div class="tarot-card-showcase-wrap">' +
        '<div class="tarot-front-frame">' +
          '<img src="' + cardImageUrl + '" alt="' + card.name + ' — ' + card.number + ' Tarot Card" class="tarot-card-artwork-img" loading="eager">' +
        '</div>' +
      '</div>';
    }

    var numberEl = modal.querySelector('[data-tarot-field="number"]');
    var nameEl = modal.querySelector('[data-tarot-field="name"]');
    var subtitleEl = modal.querySelector('[data-tarot-field="subtitle"]');
    var intentionEl = modal.querySelector('[data-tarot-field="intention"]');

    if (numberEl) { numberEl.textContent = ''; numberEl.style.display = 'none'; }
    if (nameEl) nameEl.textContent = card.name;
    if (subtitleEl) subtitleEl.textContent = card.subtitle;
    if (intentionEl) intentionEl.textContent = card.intention;

    var companionWrap = modal.querySelector('.tarot-companion-card') || modal.querySelector('.tarot-companion-block');
    if (companionWrap && card.line) {
      var bWords = (card.line.botanicals || '').split(/\s*·\s*|\s*,\s*/);
      var bHtml = bWords.filter(function(w){ return w.trim().length > 0; }).map(function(w) {
        return '<span class="tarot-overlay-word">' + w.trim() + '</span>';
      }).join('<span class="tarot-overlay-dot">&middot;</span>');
      var paperStripHtml = bHtml ? '<div class="tarot-dark-paper-overlay"><div class="tarot-overlay-words">' + bHtml + '</div></div>' : '';

      var imgKeys = Object.keys(lineImgs).filter(function(k) { return lineImgs[k]; });
      var previewHtml = '';
      if (imgKeys.length === 1) {
        var singleKey = imgKeys[0];
        previewHtml = '<div class="tarot-line-trio-preview has-1-item">' +
          '<img src="' + lineImgs[singleKey] + '" alt="' + card.line.title + ' ' + singleKey + '" class="tarot-trio-img item-single item-' + singleKey + '" loading="lazy">' +
        '</div>';
      } else if (imgKeys.length === 2) {
        previewHtml = '<div class="tarot-line-trio-preview has-2-items">' +
          '<img src="' + lineImgs[imgKeys[0]] + '" alt="' + card.line.title + ' ' + imgKeys[0] + '" class="tarot-trio-img item-duo-1 item-' + imgKeys[0] + '" loading="lazy">' +
          '<img src="' + lineImgs[imgKeys[1]] + '" alt="' + card.line.title + ' ' + imgKeys[1] + '" class="tarot-trio-img item-duo-2 item-' + imgKeys[1] + '" loading="lazy">' +
        '</div>';
      } else {
        previewHtml = '<div class="tarot-line-trio-preview has-3-items">' +
          (lineImgs.smoke ? '<img src="' + lineImgs.smoke + '" alt="' + card.line.title + ' Sacred Smoke" class="tarot-trio-img item-smoke" loading="lazy">' : '') +
          (lineImgs.spray ? '<img src="' + lineImgs.spray + '" alt="' + card.line.title + ' Sacred Spray" class="tarot-trio-img item-spray" loading="lazy">' : '') +
          (lineImgs.oil ? '<img src="' + lineImgs.oil + '" alt="' + card.line.title + ' 10ml Anointing Oil" class="tarot-trio-img item-oil" loading="lazy">' : '') +
        '</div>';
      }

      companionWrap.innerHTML = '<div class="tarot-line-recommendation-card is-collapsed" id="tarotConsiderCard" role="region">' +
        '<span class="tarot-line-badge">Consider</span>' +
        '<div class="tarot-consider-teaser" id="tarotConsiderTeaser" role="button" tabindex="0" aria-label="Tap to reveal recommendation">' +
          '<span class="tarot-consider-cta-label">Tap to reveal</span>' +
          '<svg class="tarot-consider-chevron" viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M6 9l6 6 6-6"/></svg>' +
        '</div>' +
        '<div class="tarot-consider-content" id="tarotConsiderContent">' +
          previewHtml +
          '<div class="tarot-line-info">' +
            '<h4 class="tarot-line-title">' +
              '<a href="' + resolveLineUrl(card.line) + '">' + card.line.title + '</a>' +
            '</h4>' +
            paperStripHtml +
            '<a href="' + resolveLineUrl(card.line) + '" class="side-content-btn tarot-line-explore-btn" aria-label="Explore ' + card.line.title + ' Sacred Line">' +
              'Explore &rarr;' +
            '</a>' +
          '</div>' +
        '</div>' +
      '</div>';

      var considerCard = document.getElementById('tarotConsiderCard');
      if (considerCard) {
        var revealCard = function() {
          if (considerCard.classList.contains('is-collapsed')) {
            considerCard.classList.remove('is-collapsed');
            considerCard.classList.add('is-revealed');
          }
        };

        considerCard.addEventListener('click', function(e) {
          if (considerCard.classList.contains('is-collapsed')) {
            revealCard();
          }
        });
        considerCard.addEventListener('keydown', function(e) {
          if ((e.key === 'Enter' || e.key === ' ') && considerCard.classList.contains('is-collapsed')) {
            e.preventDefault();
            revealCard();
          }
        });
      }
    }
  }

  function openModal() {
    var modal = document.getElementById('tarot-reveal-modal');
    if (!modal) return;
    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }
    modal.classList.add('active');
    document.body.style.overflow = 'hidden';
    document.body.classList.add('tarot-modal-open');

    var showcaseCard = modal.querySelector('.tarot-card-showcase-wrap');
    if (showcaseCard) {
      showcaseCard.classList.remove('revealed');
      void showcaseCard.offsetWidth;
      showcaseCard.classList.add('revealed');
    }
  }

  function closeModal() {
    var modal = document.getElementById('tarot-reveal-modal');
    if (!modal) return;
    modal.classList.remove('active');
    document.body.style.overflow = '';
    document.body.classList.remove('tarot-modal-open');
  }

  function initGrackleEyeTracker() {
    var birds = document.querySelectorAll('.interactive-grackle-tracker');
    if (!birds.length) return;

    var FRAMES = ['c', 'n', 'ne', 'e', 'se', 's', 'sw', 'w', 'nw'];

    birds.forEach(function(bird) {
      var preloaded = {};
      FRAMES.forEach(function(f) {
        var src = bird.getAttribute('data-src-' + f) || bird.src;
        var img = new Image();
        img.src = src;
        preloaded[f] = src;
      });
      bird._preloadedFrames = preloaded;
      bird._currentDir = 'c';
    });

    var ticking = false;

    window.addEventListener('mousemove', function(e) {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          birds.forEach(function(bird) {
            if (!bird.offsetParent) return;
            var rect = bird.getBoundingClientRect();
            var birdCenterX = rect.left + rect.width / 2;
            var birdCenterY = rect.top + rect.height * 0.35;

            var dx = e.clientX - birdCenterX;
            var dy = e.clientY - birdCenterY;
            var dist = Math.sqrt(dx * dx + dy * dy);

            var dir = 'c';
            if (dist > 35) {
              var angle = Math.atan2(dy, dx) * 180 / Math.PI;
              if (angle >= -22.5 && angle < 22.5) {
                dir = 'e';
              } else if (angle >= 22.5 && angle < 67.5) {
                dir = 'se';
              } else if (angle >= 67.5 && angle < 112.5) {
                dir = 's';
              } else if (angle >= 112.5 && angle < 157.5) {
                dir = 'sw';
              } else if (angle >= 157.5 || angle < -157.5) {
                dir = 'w';
              } else if (angle >= -157.5 && angle < -112.5) {
                dir = 'nw';
              } else if (angle >= -112.5 && angle < -67.5) {
                dir = 'n';
              } else if (angle >= -67.5 && angle < -22.5) {
                dir = 'ne';
              }
            }

            if (dir !== bird._currentDir) {
              bird._currentDir = dir;
              if (bird._preloadedFrames && bird._preloadedFrames[dir]) {
                bird.src = bird._preloadedFrames[dir];
              }
            }
          });
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  function initAll() {
    initTarotModule();
    initGrackleEyeTracker();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

})();
